import React from 'react';
import styled from 'styled-components';

const StyledLogoWrapper = styled.div`
  padding-top: 25px;
  > img {
    width: 345px;
  }
`;

const AuthHeader: React.FC = () => (
    <div className="row">
      <StyledLogoWrapper className="col-md-6 col-md-offset-3">
        <img src="/img/logo_v2.svg" className="img-responsive" />
      </StyledLogoWrapper>
    </div>
  );

export default AuthHeader;
